<template>
    <vue-my-multi-select
        :name="name"
        :selected-name="selectedName"
        :options="tags"
        :values="values"
        :placeholder="placeholder"
        :values-map="mapInitialOptions"
        :track-by="'text'"
        :on-add-tag="onAddTag">
        <template v-slot:new-tags-input="props" >
            <input v-for="(option, index) in props.selectedNewOptions" :key="`${name}__nonxistent__${index}`" type="hidden" :name="`${name}[${index}][title]`" :value="option.text">
        </template>
        <template slot="noOptions">
            Nenhuma Tag existente
        </template>
    </vue-my-multi-select>

</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
export default {
    props:{
        name: String | Function,
        placeholder: String,
        selectedName: {
            type: String | Function,
            default: null
        },
        values:{
            type: Array,
            default: ()=>[]
        },
    },
    computed:{
        ...mapState('meetFormModule', ['tags', 'meet'])
    },
    methods: {
        mapInitialOptions(option){
            return {text: option.title, value: option.id}
        },
        onAddTag(newTagData, selectedOptions){
            this.$apiService.createTag({
                tagData: {title: newTagData, tenant_id: this.meet.tenant_id},
                onSucess: (response)=>{
                    var _newTag = {
                        text: response.data.title,
                        value: response.data.id,
                        new: false
                    }
                    this.addTag(_newTag)
                    selectedOptions.push(_newTag);
                }
            })
        },
        ...mapActions('meetFormModule', ['addTag'])
    }
}
</script>